import classNames from 'classnames';
import React from 'react';
import './FiftyFifty.css';
import { PTInfo } from './PTElements';

export const FiftyFiftyElement = ({ options, onChange, children, field, subLabelOnSelect, infoColour, form, form: { errors, setFieldValue, values }, ...props }) => {
    if (!options) {
        throw new Error('Invalid Fifty/Fifty options');
    }

    const selectOption = option => {
        if (values[field.name] === option.value) {
            setFieldValue(field.name, '');
        }
        else {
            setFieldValue(field.name, option.value);
            if (onChange) {
                onChange(option);
            }
        }
    };

    return (
        <div className={classNames("fifty-fifty-wrapper", { 'vertical': options.length > 2 })} {...props}>
            <div className="fifty-fifty">
                {options.map(o =>
                    <div key={o.value} className={classNames("fifty-fifty-option", {
                        active: field.value === o.value,
                        hasInfo: o.selectedInfo && field.value === o.value,
                        hasLabel: (o.subLabel && (!subLabelOnSelect || field.value === o.value)) || (children && field.value === o.value)
                    })} onClick={() => selectOption(o)}>
                        <span>{o.label}{o.selectedInfo && field.value === o.value && <PTInfo info={o.selectedInfo} colour={infoColour || "white"} />}</span>
                        {o.subLabel && (!subLabelOnSelect || field.value === o.value) && <div>{o.subLabel}</div>}
                        {children && field.value === o.value && <div className="fifty-fifty-content" onClick={(e) => e.stopPropagation()}>{children}</div>}
                    </div>)}
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/FiftyFiftyElement.js